import React from "react";
import { Bundle } from "src/types/global";

const BundleList = ({
  bundles,
  onClick,
  currentBundle,
}: {
  bundles: Bundle[];
  currentBundle: Bundle | undefined;
  onClick: Function;
}) => {
  if (!currentBundle) {
    currentBundle = bundles[0];
  }
  return (
    <div className="bundles-container">
      {bundles.map((bundle: Bundle, index: number) => {
        const isActive = bundle.tieredName === currentBundle?.tieredName;
        return (
          <div
            key={bundle.id}
            onClick={() => {
              onClick(bundle);
            }}
            className={`bundle-container${isActive ? " active" : ""}`}
          >
            <div
              className="navBtn"
              dangerouslySetInnerHTML={{
                __html: bundle.tieredName,
              }}
            ></div>
            <span className="desc">
              {bundle.tieredDescription}
            </span>
          </div>
        );
      })}
    </div>
  );
};
export default BundleList;
